/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Hello : 'Hello',
        ButtonLogout: 'ButtonLogout',
        ButtonLogin: 'ButtonLogin',
        TitleChild: 'TitleChild',
        TotalIndex: 'TotalIndex',
        LoginBot: 'LoginBot',
        Question: 'Question',
        Comment: 'Comment',
        ButtonSelectLogin: 'ButtonSelectLogin',
        InfoBot1: 'InfoBot1', 
        Reselect: 'Reselect', 
        SelectLoginBot: 'SelectLoginBot', 
        Placeholder: 'Placeholder',
        LogoutBot: 'LogoutBot', 
        PlaceholderId: 'PlaceholderId',// '회원번호 혹은 아이디, 닉네임을 입력해주세요.',
        PlaceholderPw: 'PlaceholderPw',// '비밀번호를 입력해주세요.',
        PlaceholderSearch: 'PlaceholderSearch',
        LowerLoginBot: 'LowerLoginBot',// '하위회원으로 로그인하려면,<br>[하위회원으로 로그인하기]를 눌러주세요.',
        LowerLogin: 'LowerLogin',// '하위회원으로 로그인하기',
        Logout: 'Logout',// '현재 계정에서 로그아웃하기',
        CheckIt: 'CheckIt',// '* 회원번호/아이디/닉네임 또는 비밀번호를 다시 확인해주세요.',
        NotFound: 'NotFound', // 검색결과가 없어요.
        FavoriteInfo: 'FavoriteInfo',
        MemberSetting: 'MemberSetting',
        Info: 'Info',
        FindMember: 'FindMember', // 상단 검색창에 회원을 검색하세요.
        FavoriteSet: 'FavoriteSet', // 관심회원 설정안내    
        SalesCur: 'SalesCur',   // 현재 매출
        SalesTotal: 'SalesTotal', // 총 매출
        LoginMoreInfo: 'LoginMoreInfo', // 좋아요! 로그인하면 더 많은 안내를 받을 수 있어요. 아래에 로그인 정보를 입력하세요.
        NoLogin: 'NoLogin',
        LoginTitle: 'LoginTitle',
        LoginTwice: 'LoginTwice', //이미 로그인중인경우
        SelectLogin: 'SelectLogin',
        NomemberTitle: 'NomemberTitle', // 비회원이십니까?
    },
    tomy:{
        kr: {
            SelectLogin: '선택한 계정으로 로그인',
            Hello : '애터미 Village에 온 걸 환영해요.<br>쇼핑 여정에 함께할 PAPA 파파예요.',
            TitleChild: '관심회원선택',
            TotalIndex: '<strong><em class="cur">{count}</em>명</strong> / 총 <em class="total">{total}</em>명',
            LoginBot: '로그인정보를 입력해주세요',
            Question: '애터미 회원이신가요?',
            Comment: '로그인하면 더 많은 안내를...',
            ButtonLogin: '로그인하기',
            ButtonSelectLogin: '이 계정으로 로그인하기',
            InfoBot1: '안녕하세요. <b>{name}님,</b> 최근 직급내역과 후원수당을 확인해보세요.', 
            Reselect: '계정 다시 선택하기', 
            SelectLoginBot: '선택한 계정으로 로그인하려면 비밀번호를 입력해주셔야 합니다.', 
            Placeholder: '비밀번호를 입력해주세요',
            LogoutBot: '아래 버튼을 누르면, 현재 계정에서 로그아웃됩니다.',
            PlaceholderId: '회원번호(아이디)를 입력해 주세요.', //
            PlaceholderPw: '비밀번호를 입력해주세요.',
            PlaceholderSearch: '관심회원의 회원번호나 회원명을 입력하세요.',
            LowerLoginBot: '관심회원의 정보를 확인하고 싶으신가요? 아래 [관심회원으로 로그인하기]를 누르시면 됩니다.',
            LowerLogin: '관심회원으로 로그인하기',
            Logout: '현재 계정에서 로그아웃하기',
            CheckIt: '* 회원번호/아이디/닉네임 또는 비밀번호를 다시 확인해주세요.',
            NotFound: '검색결과가 없어요.', // 
            FavoriteInfo: '챗봇에서는 관심회원을 설정할 수 없어요. 관심회원을 추가하거나 해제하려면 아래 버튼을 눌러주세요.',
            MemberSetting: '관심회원 설정하러 가기',
            Info: '모바일에서 등록하신 관심회원이 노출됩니다.',
            FindMember: '상단 검색창에<br> 회원을 검색하세요.',  
            FavoriteSet: '관심회원 설정 안내',  
            SalesCur: '현재 매출',   // 현재 매출
            SalesTotal: '총 매출', // 총 매출     
            ButtonLogout: '로그아웃하기', 
            LoginMoreInfo: '좋아요! 로그인하면 더 많은 안내를 받을 수 있어요. 아래에 로그인 정보를 입력하세요.',
            NoLogin: '',
            LoginTitle: '로그인',
            LoginTwice: '{name}님, 이미 로그인하신 상태입니다. 관심회원으로 로그인하시겠어요?',
            NomemberTitle: '비회원이신가요?', // 비회원이십니까?
        },
        eng: {
            SelectLogin: 'Log in with the selected account',
            Hello : 'Hello and welcome to Atomy Village!<br>I am PAPA,and we will go shopping together.',
            TitleChild: 'Interested member selection',
            TotalIndex: '<strong><em class="cur">{count}</em></strong> / total <em class="total">{total}</em>',
            LoginBot: 'Please enter your login information.',
            Question: 'Are you an Atomy member?',
            Comment: 'Log in for more information',
            ButtonLogin: 'log in',
            ButtonSelectLogin: 'Log in with this account',
            InfoBot1: 'Hello. <b>{name},</b> Please check the details related to the general commission.', 
            Reselect: 'Select your account again', 
            SelectLoginBot: 'You will be asked to enter your password to log in with the selected account.', 
            Placeholder: 'Please enter a password.',
            LogoutBot: 'Click the button below to log out of your current account.',
            PlaceholderId: 'Please enter your membership number (ID).',
            PlaceholderPw: 'Please enter your password.',
            PlaceholderSearch: 'Enter your Interested member number',
            LowerLoginBot: 'Do you want to check the Interested members information? Click [Login as a Interested members] below.',
            LowerLogin: 'Log in as a Interested member',
            Logout: 'Log out of your current account',
            CheckIt: '※ Check your membership number/ID/nickname or password again.',
            NotFound: 'No search results.', // 
            FavoriteInfo: 'You cannot "set" interested members in the chatbot. Click the button below to add or remove interested members.',
            MemberSetting: 'Go to interested members',
            Info: 'Interested members registered on mobile are exposed.',
            FindMember: 'Search for members in the search bar at the top.',  
            FavoriteSet: 'Interested member setting guide',   
            SalesCur: 'current sales',   // 현재 매출  
            SalesTotal: 'total sales', // 총 매출
            ButtonLogout: 'log out',
            LoginMoreInfo: 'good! Log in for more information. Enter your login information below.',
            NoLogin: '',
            LoginTitle: 'Login',
            LoginTwice: 'You are already logged in. To log in as a Interested members, please press the [Log in as Interested members] button at the bottom.',
            NomemberTitle: '비회원이신가요?', // 비회원이십니까?
        },    
    },
    papa:{
        kr: {
            SelectLogin: '선택한 계정으로 로그인',
            Hello : '애터미 Village에 온 걸 환영해요.<br>쇼핑 여정에 함께할 PAPA 파파예요.',
            TitleChild: '관심회원선택',
            TotalIndex: '<strong><em class="cur">{count}</em>명</strong> / 총 <em class="total">{total}</em>명',
            LoginBot: '로그인정보를 입력해주세요',
            Question: '애터미 회원이신가요?',
            Comment: '로그인하면 더 많은 안내를 받을 수 있어요.',
            ButtonLogin: '로그인하기',
            ButtonSelectLogin: '이 계정으로 로그인하기',
            InfoBot1: '안녕하세요. <b>{name}님,</b> 최근 직급내역과 후원수당을 확인해보세요.', 
            Reselect: '계정 다시 선택하기', 
            SelectLoginBot: '좋아요. 해당 회원의 로그인 정보를 입력하세요.', 
            Placeholder: '비밀번호를 입력해주세요',
            LogoutBot: '완전히 로그아웃하려면 아래 버튼을 누르세요.',
            PlaceholderId: '회원번호(아이디)를 입력해 주세요.',
            PlaceholderPw: '비밀번호를 입력해주세요.',
            PlaceholderSearch: '관심회원의 회원번호나 회원명을 입력하세요.',
            LowerLoginBot: '관심회원의 정보를 보고 싶다면 아래 [관심회원으로 로그인하기] 버튼을 누르세요.',
            LowerLogin: '관심회원으로 로그인하기',
            Logout: '현재 계정에서 로그아웃하기',
            CheckIt: '* 회원번호/아이디/닉네임 또는 비밀번호를 다시 확인하세요.',
            NotFound: '검색결과가 없어요.', // 
            FavoriteInfo: '챗봇에서는 관심회원을 설정할 수 없어요. 관심회원을 추가하거나 해제하려면 아래 버튼을 눌러주세요.',
            MemberSetting: '관심회원 설정하러 가기',
            Info: '모바일에서 등록하신 관심회원이 노출됩니다.',
            FindMember: '상단 검색창에<br> 회원을 검색하세요.',  
            FavoriteSet: '관심회원 설정 안내',     
            SalesCur: '현재 매출',   // 현재 매출
            SalesTotal: '총 매출', // 총 매출
            ButtonLogout: '로그아웃하기',
            LoginMoreInfo: '좋아요! 로그인하면 더 많은 안내를 받을 수 있어요. 아래에 로그인 정보를 입력하세요.',
            NoLogin: '아하, 그건 로그인을 해야 보여드릴 수 있어요. 아래에서 로그인을 먼저 하겠어요?',
            LoginTitle: '로그인',
            LoginTwice: '{name}님은 로그인 상태예요. 관심회원 계정으로 로그인하려면 아래 버튼을 누르세요.',
            NomemberTitle: '비회원이신가요?', // 비회원이십니까?
        },
        eng: {
            SelectLogin: 'Log in with the selected account',
            Hello : 'Welcome. This is PAPA who will go shopping together. When you find me, just call me Papa.',
            TitleChild: 'Interested members selection',
            TotalIndex: '<strong><em class="cur">{count}</em></strong> / total <em class="total">{total}</em>',
            LoginBot: 'Please enter your login information.',
            Question: 'Are you an Atomy member?',
            Comment: 'Log in for more information.',
            ButtonLogin: 'log in',
            ButtonSelectLogin: 'Log in with this account.',
            InfoBot1: 'Hello, <b>{name},</b> Please check the details related to the general commission.', 
            Reselect: 'Select your account again.', 
            SelectLoginBot: "Good. Enter the member's login information.", 
            Placeholder: 'Please enter your password.',
            LogoutBot: 'Click the button below to log out completely',
            PlaceholderId: 'Please enter your membership number (ID).',
            PlaceholderPw: 'Please enter a password.',
            PlaceholderSearch: 'Enter your Interested members number',
            LowerLoginBot: 'If you want to view the information of a Interested members, click the [Login as a Interested members] button below.',
            LowerLogin: 'Log in as a Interested members',
            Logout: 'Log out of your current account',
            CheckIt: '※ Check your membership number/ID/nickname or password again.',
            NotFound: 'No search results.', // 
            FavoriteInfo: "You cannot 'set' interested members in the chatbot. Click the button below to add or remove interested members.",
            MemberSetting: 'Go to interested members',
            Info: 'Interested members registered on mobile are shown.',
            FindMember: 'Enter member in the search bar at the top.',  
            FavoriteSet: 'Interested member settings guide',     
            SalesCur: 'Current sales',   // 현재 매출
            SalesTotal: 'Total sales', // 총 매출
            ButtonLogout: 'Log out',
            LoginMoreInfo: 'good! Log in for more information. Enter your login information below.',
            NoLogin: 'Aha, you need to log in to see that, would you like to log in from below?',
            LoginTitle: 'Login',
            LoginTwice: 'You are already logged in. To log in as a downliner, please press the [Log in as downliner] button at the bottom.',
            NomemberTitle: '비회원이신가요?', // 비회원이십니까?
        },    
    },
};
